import React, { ChangeEvent, useState } from 'react';
import * as S from './styles';

interface IToogleButton {
  onClick: () => Promise<void>;
  value: boolean;
  isBlocked: boolean;
}

const ToggleButton = ({ onClick, isBlocked, value}: IToogleButton) => {
  const [checked, setChecked] = useState(value || false);
  const [temporaryBlocked, setTemporaryBlocked] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if(isBlocked || temporaryBlocked) return;
    
    setChecked(e.target.checked);
    setTemporaryBlocked(true);

    onClick().finally(() =>{
      setTemporaryBlocked(false);
    });
    return;
  }

  return (
    <S.Label isBlocked={isBlocked} checked={checked}>
      <S.Input
       checked={checked}
       disabled={isBlocked}
       type="checkbox"
       onChange={handleChange}
      />
      <S.Switch isBlocked={isBlocked} checked={checked}/>
    </S.Label>
  );
};

export default ToggleButton;